import { getMemberHost } from "config";
import { authenticatedFetch } from "./authenticatedFetch";

export const fetchFeatures = async (companyId: number): Promise<string[]> => {
  return await authenticatedFetch<string[]>(`https://${getMemberHost()}/affapi/company/${companyId}/features`);
};
